import ExpiringTower from './ExpiringTower';

export default ExpiringTower;
